import { Box, CssBaseline, Typography } from "@mui/material";

export default function AccessDenied() {
  return (
    <>
      <CssBaseline />
      <Box width={'100vw'} height={'100vh'} position='relative'>
        <img src="/assets/images/tank.jpg" style={{ objectFit: 'cover', width: '100%', height: '100%' }} alt="bg" />
        <Box 
          sx={{
            position: 'absolute',
            top: '50%',
            width: '100vw',
            transform: 'translate(0, -50%)',
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, .5)',
            gap: 3
          }}
        >
          <img src="/assets/logo.png" width={100} height={100} alt="logo" />
          <Typography fontWeight={600} variant="h4" color='white'>Oops</Typography>
          <Typography fontSize={20} color='white'>we have looked you does not have access to this page</Typography>
        </Box>
      </Box>
    </>
  )
}